module.exports = __webpack_public_path__ + "media/img/wedding_success/devices-587c38add952bd91b4036437422fe7a8.png";